/* © CNES */
import { SelectButtonItem } from '../../../models/SelectButtonItem';
import { Missions } from './Referenciel';

export const productTypeOptions: SelectButtonItem[] = [
  {
    key: 'Vegetation',
    name: 'Vegetation',
    value: 1,
    color: 'green',
    missionId: [Missions.postel, Missions.GEOV2_AVHRR],
  },
  {
    key: 'Radiation',
    name: 'Radiation',
    value: 2,
    color: 'green',
    missionId: [Missions.postel],
  },
  {
    key: 'Water',
    name: 'Water',
    value: 3,
    color: 'green',
    missionId: [Missions.postel],
  },
  {
    key: 'LandCover',
    name: 'LandCover',
    value: 4,
    color: 'green',
    missionId: [Missions.postel],
  },
];

export const allVariableOptions = [
  { key: 'LAI', name: 'LAI', value: 1, productTypeId: 1, color: 'green' },
  {
    key: 'Fcover',
    name: 'FCOVER',
    value: 2,
    productTypeId: 1,
    color: 'green',
  },
  { key: 'FAPAR', name: 'FAPAR', value: 3, productTypeId: 1, color: 'green' },
  { key: 'NDVI', name: 'NDVI', value: 4, productTypeId: 1, color: 'green' },
  {
    key: 'SurfaceReflectance',
    name: 'Surface Reflectance',
    value: 5,
    productTypeId: [1, 2],
    color: 'green',
  },
  { key: 'BRDF', name: 'BRDF', value: 6, productTypeId: 2, color: 'green' },
  { key: 'DLR', name: 'DLR', value: 14, productTypeId: 2, color: 'green' },
  {
    key: 'SurfaceAlbedo',
    name: 'Surface Albedo',
    value: 7,
    productTypeId: 2,
    color: 'green',
  },
  {
    key: 'SurfaceTemperature',
    name: 'Surface Temperature',
    value: 8,
    productTypeId: 2,
    color: 'green',
  },
  {
    key: 'SOILMOISTURE',
    name: 'Soil Moisture',
    value: 9,
    productTypeId: 3,
    color: 'green',
  },
  { key: 'SWI', name: 'SWI', value: 10, productTypeId: 3, color: 'green' },
  {
    key: 'SURFWET',
    name: 'SurfWet',
    value: 11,
    productTypeId: 3,
    color: 'green',
  },
  {
    key: 'PRECIPITATION',
    name: 'PRECIP',
    value: 12,
    productTypeId: 3,
    color: 'green',
  },
  {
    key: 'Globcover',
    name: 'Globcover',
    value: 13,
    productTypeId: 4,
    color: 'green',
  },
];

/**
 * Product Types Names.
 */
export const postelGeoserverTypes = {
  SOILMOISTURE: 'SOILMOISTURE',
  FCOVER: 'FCOVER',
  DLR: 'LONGWAVERADIATION',
  BRDF: 'BRDF',
  SURFACEREFLECTANCE: 'SURFACEREFLECTANCE',
  FAPAR: 'FAPAR',
  LAI: 'LAI',
  NDVI: 'NDVI',
  PRECIPITATION: 'PRECIPITATION',
  SURFACEALBEDO: 'SURFACEALBEDO',
  SURFACETEMPERATURE: 'SURFACETEMPERATURE',
  SWI: 'SWI',
  SURFWET: 'SURFWET',
  GLOBCOVER: 'GLOBCOVER',
};
